import type { ReactNode } from 'react'
import { AuthProvider } from './AuthProvider'
import { QueryProvider } from './QueryProvider'
import { TenantProvider } from './TenantProvider'
import { ToastProvider } from './ToastProvider'

/**
 * Provider order matters:
 *   Query  -> TenantProvider issues a query
 *   Auth   -> must wire the API client before any query can run
 *   Tenant -> depends on auth status
 *   Toast  -> outermost consumer, used by everything
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <AuthProvider>
        <TenantProvider>
          <ToastProvider>{children}</ToastProvider>
        </TenantProvider>
      </AuthProvider>
    </QueryProvider>
  )
}
